<template>
  <div class="product-preview">
    <lazy-image
      :class-name="'product-preview-image'"
      :item="lazyPicture"
      rootMargin="0px"
      :loading="'lazy'"
      :render-when-appeared="true"
    ></lazy-image>
    <div>
      <h4>{{ this.item.name }}</h4>
      <p>{{ this.item.product.manufacturer_sku }}</p>
    </div>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import LazyImage from './LazyImage.vue'

export default {
  name: 'ProductMiniPreview',
  props: ['item', 'picture'],
  mixins: [ReadyHook],
  components: {
    LazyImage
  },
  computed: {
    lazyPicture() {
      return {
        url: this.picture.src,
        lowDefinitionUrl: ImageManager.getLowDefinition(
          this.picture.src,
          150,
          1,
          true
        ),
        srcset: ImageManager.getSrcSet(
          this.picture.src,
          1600,
          600,
          100,
          1,
          true
        ),
        alt: '',
        width: this.picture.width,
        height: this.picture.height
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
.product-preview {
  background-color: $light-grey;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  h4 {
    margin-bottom: 4px;
  }
  p {
    margin: 0;
  }
  &-image {
    margin: 0 25px;
    width: 50px;
    max-height: 100px;
    overflow: hidden;
  }
}
</style>
